import './style.scss';
import Icon from './icon.js';

export default Icon;